@if (show$ | async) {
  <section aria-label="cookies-consents">
    <div class="layout-container">
      <h2 i18n="cookie-consents|Title" class="wrapper">We use cookies</h2>
      <p i18n="cookie-consents|Text" class="wrapper">
      Please accept cookies. For any questions refer to <a class="app-link" routerLink="/cookies-policy" data-testid="cookie-overlay-policy-link">Cookies policy</a>
    </p>
      <div class="actions wrapper">
        <button type="button" matButton="outlined" data-testid="cookie-overlay-change-button" i18n="cookie-consents|Preferences button" (click)="openPreferencesCenter()">Change preferences</button>
        <button type="button" matButton="filled" data-testid="cookie-overlay-agree-button" i18n="cookie-consents|Agree for all button" appClickTriggerFor=".cc-nb-okagree">I agree</button>
        <button type="button" class="btn-color-warn" matButton="filled" data-testid="cookie-overlay-disagree-button" i18n="cookie-consents|Reject button" appClickTriggerFor=".cc-nb-reject">I disagree</button>
      </div>
    </div>
  </section>
}
